import { useIntl } from '@/intl'
import { Sheet } from '@sunwebgroup/ui-components/uds'
import { AddBooking } from './AddBooking'

interface AddBookingSheetProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  contextItemId: string
}

export function AddBookingSheet({
  isOpen,
  onOpenChange,
  contextItemId,
}: AddBookingSheetProps) {
  const intl = useIntl()

  return (
    <Sheet.Root open={isOpen} onOpenChange={onOpenChange}>
      <Sheet.Body side="right">
        <Sheet.Header
          titleLabel={intl.formatMessage({ id: 'bookings_overview_add_booking' })}
          closeLabel={intl.formatMessage({ id: 'close' })}
        />
        <Sheet.Content>
          <AddBooking contextItemId={contextItemId} />
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
